<script setup>
import CheckBox from 'v3/components/Form/CheckBox.vue';

defineProps({
  label: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['change']);
const onChange = (id, value) => {
  emit('change', id, value);
};
</script>

<template>
  <div class="grid items-start grid-cols-12 gap-4">
    <div class="col-span-12 sm:col-span-3">
      <label class="text-sm font-medium leading-6 text-ash-900">
        {{ label }}
      </label>
    </div>

    <div class="flex flex-col col-span-12 gap-3 sm:col-span-8">
      <div
        v-for="item in items"
        :key="item.id"
        class="flex items-start gap-2"
      >
        <CheckBox
          :is-checked="item.model"
          :value="item.value"
          @update="onChange"
        />
        <label
          class="text-sm font-normal text-ash-900"
          :for="item.value"
        >
          {{ item.label }}
        </label>
      </div>
    </div>
  </div>
</template>